// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '@app/core';

const MAX_CHARS = 13;

@Pipe({
  name: 'userRoles'
})
export class UserRolesPipe implements PipeTransform {
  public transform(roles: UserRole[]): any {
    if (roles.length < 1) {
      return undefined;
    }
    const primaryRoleName = roles[0].name;
    return `(${roles.length}) ${this.truncate(primaryRoleName)}`;
  }

  private truncate(roleName: string) {
    if (roleName.length < MAX_CHARS) {
      return roleName;
    }
    return `${roleName.substring(0, MAX_CHARS)}...`;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/user-roles.pipe.ts